import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-67e7e940"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal uploadCertificationModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "body"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "input_title" }
const _hoisted_14 = { class: "mt-4 d-block" }
const _hoisted_15 = { class: "col-sm-3" }
const _hoisted_16 = { class: "col-sm-3" }
const _hoisted_17 = { class: "col-sm-3" }
const _hoisted_18 = { class: "text-center mt-3" }
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Water Footprint Configuration",
          text: "Water Footprint Configuration"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_form_field, {
                type: "select",
                labelKey: "Raw Material",
                labelValue: "Raw Material",
                placeholderKey: "Raw Material",
                placeholderValue: "Raw Material",
                list: _ctx.availableRawMaterials,
                modelValue: _ctx.model.rawMaterialIdentifier,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.rawMaterialIdentifier) = $event)),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDefaultConfiguration()))
              }, null, 8, ["list", "modelValue"])
            ])
          ]),
          (_ctx.model.waterFootprints.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.waterFootprints, (waterFootpr, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Production Phase",
                            text: "Production Phase",
                            class: "fev_text5 fw_600"
                          })
                        ]),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.model.waterFootprints[index].productionPhase.text), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_form_field, {
                        type: "number",
                        labelKey: "Green water (ml/g)",
                        labelValue: "Green water (ml/g)",
                        placeholderKey: "Green water (ml/g)",
                        placeholderValue: "Green water (ml/g)",
                        modelValue: _ctx.model.waterFootprints[index].greenWater,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.model.waterFootprints[index].greenWater) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_form_field, {
                        type: "number",
                        labelKey: "Blue water (ml/g)",
                        labelValue: "Blue water (ml/g)",
                        placeholderKey: "Blue water (ml/g)",
                        placeholderValue: "Blue water (ml/g)",
                        modelValue: _ctx.model.waterFootprints[index].blueWater,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.model.waterFootprints[index].blueWater) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_form_field, {
                        type: "number",
                        labelKey: "Grey water (ml/g)",
                        labelValue: "Grey water (ml/g)",
                        placeholderKey: "Grey water (ml/g)",
                        placeholderValue: "Grey water (ml/g)",
                        modelValue: _ctx.model.waterFootprints[index].greyWater,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.model.waterFootprints[index].greyWater) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-tertiary",
        disabled: _ctx.isSaveDisabled,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save()))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Save",
          text: "Save"
        })
      ], 8, _hoisted_19)
    ])
  ]))
}